import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TooltipConfig } from './tooltip-config';

@Component({
  selector: 'mtg-tooltip',
  templateUrl: './tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  @HostBinding('class.tooltip')
  defaultClass = true;

  @HostBinding('class.tooltip--size-sm')
  get sizeSm() {
    return this.tooltipConfig.size === 'sm';
  }

  @HostBinding('class.tooltip--size-md')
  get sizeMd() {
    return this.tooltipConfig.size === 'md' || !this.tooltipConfig.size;
  }

  @HostBinding('class.tooltip--position-top')
  get positionTop() {
    return this.tooltipConfig.position === 'top';
  }

  @HostBinding('class.tooltip--position-bottom')
  get positionBottom() {
    return this.tooltipConfig.position === 'bottom';
  }

  @HostBinding('class.tooltip--position-start')
  get positionStart() {
    return this.tooltipConfig.horizontalPosition === 'start';
  }

  @HostBinding('class.tooltip--position-center')
  get positionCenter() {
    return this.tooltipConfig.horizontalPosition === 'center';
  }

  @HostBinding('class.tooltip--position-end')
  get positionEnd() {
    return this.tooltipConfig.horizontalPosition === 'end';
  }

  constructor(
    private tooltipConfig: TooltipConfig
  ) {}

  get content() {
    if (typeof this.tooltipConfig.content === 'string') {
      return null;
    }
    return this.tooltipConfig.content;
  }

  get text() {
    if (typeof this.tooltipConfig.content !== 'string') {
      return null;
    }
    return this.tooltipConfig.content;
  }
}
